import { Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/guards/auth.guard';

export const HEALTH_REGISTRATION_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./health-registration.component').then(m => m.HealthRegistrationComponent),
    canActivate: [AuthGuard],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./health-registration-detail/health-registration-detail.component').then(m => m.HealthRegistrationDetailComponent),
    canActivate: [AuthGuard],
  }
];
